import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import UserApi from "../../apis/user.api";
import { PremiumServiceSvg } from "../../components/Assets";
import TopPageBack from "../../components/TopPageBack";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import { CEO_TYPES } from "../../constants/AppConstants";
import { ROUTE_PATHS } from "../../constants/Router";
import useAuth from "../../hooks/useAuth";
import { store, useSelector } from "../../store";
import Str2DateWithDot from "../../utils/Str2DateWithDot";
import PremiumServiceCards from "./PremiumServiceCards";
import CmmApi from '../../apis/cmm.api';

const CancelPremiumDeleteRequest = function () {
  const navigate = useNavigate();
  const { ceoInfo } = useAuth();

  const isPremiumUser = ceoInfo?.ceo_type === CEO_TYPES.PREMIUM;
  const [isPremiumDeleted, setIsPremiumDeleted] = useState(false);
  const [requestCancelPremiumtDttm, setRequestCancelPremiumtDttm] = useState('');
  const [estimatedCancelPremiumDttm, setEstimatedCancelPremiumDttm] = useState('');
  const [loading, setLoading] = useState(false);
  const { ceo } = useSelector((state) => state.Ceo);

  useEffect(() => {
   setIsPremiumDeleted(store.getState().CeoStatus['canceledPremium']);
   setRequestCancelPremiumtDttm(store.getState().Ceo['requestCancelPremiumtDttm']);
   setEstimatedCancelPremiumDttm(store.getState().Ceo['estimatedCancelPremiumDttm']);
  }, []);

  const onSubmit = async () => {
    setLoading(true);
    try {
      const res = await UserApi.cancelDeletePremium();
      if (res.data.data) {
        navigate(ROUTE_PATHS.Home);
      }
    } catch (error) {

    } finally {
      setLoading(false);
    }
  }
const handleSaleLink = async () =>{
  const res = await CmmApi.getManagerCodeByShopIdx(ceoInfo.shop_idx);
  if(res.data){
    //using set timeout bc window.open not working on safari
    setTimeout(() => {
    window.open(`${process.env.REACT_APP_SALE_ENPOINT}/apply/${res.data}/shop/${ceoInfo.shop_idx}`,'_blank', 'rel=noopener noreferrer')
    })
  }
}
  return (
    <div>
      <TopPageBack>
        <b>프리미엄 서비스 관리</b>
      </TopPageBack>      
      {isPremiumUser && isPremiumDeleted ? (        
        <div className="mx-5 pb-16">
          <div className="h-4"></div>
          <div className="text-lg font-bold mb-1">프리미엄 서비스 해지 신청이</div>
          <div className="text-lg font-bold mb-1">접수 완료되었어요.</div>
          <div className="text-15 text-darkblue">서비스 탈퇴는 프리미엄 서비스 해지 이후에 가능해요.</div>

          <div className="review-card2 py-4 mt-6 flex flex-col">
            <div className="flex flex-col gap-2">
              <div className="text-lg font-bold mb-1">신청 정보</div>
              <div className="bg-light-aqua2 p-4 rounded-lg ">
                <div className="mb-6">
                  <div className="text-15 text-darkblue">해지 신청일</div>
                  <div className="text-base font-bold text-darkblue">
                    { Str2DateWithDot(requestCancelPremiumtDttm)}
                  </div>
                </div>
                <div>
                  <div className="text-base text-darkblue">해지 예정일</div>
                  <div className="text-base font-bold text-darkblue">
                    {estimatedCancelPremiumDttm?.replaceAll('/','.')}<span className="font-normal">(00시)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="pt-3 mx-5">
            <ul>
              <li style={{ listStyleType: "initial" }} className=" mb-5  text-base text-darkblue">
                탈퇴 예정일까지는 모든 서비스를 정상적으로 이용하실 수 있어요.
              </li>
            </ul>
          </div>

          <div className="pt-3 mb-10">
            <div className=" mb-5  text-base font-bold text-darkblue">
              프리미엄 전용 기능
            </div>
            <PremiumServiceCards />
          </div>

          <SolidBlueBtn
            className="w-full text-center"
            onClick={onSubmit}
          >
            프리미엄 서비스 해지 취소
          </SolidBlueBtn>
        </div>
      ) : (
        <div
          style={{
            height: "calc(85vh - 85px)",
          }}
          className="flex flex-col w-screen h-screen items-center text-center justify-center px-[30px] "
        >
          <div className="mb-6">
            <img src={PremiumServiceSvg} />
          </div>
          <div className="font-bold mb-2">
            프리미엄에서만 이용하실 수 있어요.
          </div>
          <div className="mb-7 text-blue">
            사장님 리뷰를 대신 관리하고 분석해 드려요. 고객과의 소통은 저희에게
            맡기시고 장사에만 집중하세요.
          </div>
          <div className="text-[#3451d7]">
            첫 가입 시 한 달 무료체험을 할 수 있어요!
          </div>
          <div className="w-full items-center flex justify-center">
            <SolidBlueBtn
              onClick={handleSaleLink}
              className="mt-6"
              style={{ padding: "8px 20px" }}
            // onClick={() => navigate(ROUTE_PATHS.EditCardManage)}
            >
              무료 체험 신청하기
            </SolidBlueBtn>
          </div>
        </div>
      )}
    </div>
  );
};
export default CancelPremiumDeleteRequest;
